import type { ReactNode } from 'react';

import { useIsClient } from '#/hooks/useIsClient';

type Props = {
  children: ReactNode;
  placeholder?: ReactNode;
};

export function ClientOnly({ children, placeholder = null }: Props) {
  const isClient = useIsClient();

  return isClient ? children : placeholder;
}
